import React, { useState } from 'react';
import {
  FiBriefcase,
  FiMapPin,
  FiClock,
  FiSend,
  FiUser,
  FiTrendingUp,
  FiCoffee,
  FiAward,
  FiShield,
  FiPhone,
  FiCheckCircle
} from 'react-icons/fi';
import RmbIcon from '../../components/RmbIcon';
import './Careers.css';
import { addForm } from '../../api/gwform.js';
import { message } from 'antd';
const Careers = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    remark: '',
    resume: '',
    source: '识道造价'
  });

  const positions = [
    {
      title: '注册造价工程师（土建/安装）',
      location: '宁波',
      salary: '18K-35K · 14薪 + 项目分成',
      type: '全职',
      requirements: [
        '本科及以上学历，工程造价、土木工程等相关专业',
        '持有一级造价工程师注册证书（土建或安装）',
        '5年以上全过程造价咨询经验，熟悉市政、房建或轨道交通项目',
        '具备限额设计、动态成本控制、造价审核等实战经验',
        '熟练使用广联达、工程算量、AI审核平台等工具'
      ]
    },
    {
      title: 'AI算法工程师（造价智能审核方向）',
      location: '宁波',
      salary: '25K-45K · 16薪 + 期权',
      type: '全职',
      requirements: [
        '硕士及以上学历，计算机、人工智能、数学相关专业',
        '3年以上机器学习/深度学习工作经验，熟悉 NLP / CV / 知识图谱',
        '有工程造价、BIM、建筑图纸识别等垂直领域经验优先',
        '熟悉 TensorFlow / PyTorch 等框架，具备模型部署经验',
        '对行业数字化转型有热情，愿意与造价专家深度共创'
      ]
    },
    {
      title: 'BIM+造价工程师',
      location: '宁波',
      salary: '15K-28K · 13薪 + 年终奖',
      type: '全职',
      requirements: [
        '本科及以上学历，工程造价、土木工程、建筑学等相关专业',
        '3年以上 BIM 建模或造价咨询经验，熟悉 Revit / Navisworks',
        '能够基于 BIM 模型完成工程量提取与指标沉淀',
        '熟悉正向设计流程，具备多专业协调能力',
        '持有造价工程师或 BIM 工程师证书优先'
      ]
    },
    {
      title: '招标代理经理',
      location: '宁波',
      salary: '12K-22K · 13薪 + 项目奖金',
      type: '全职',
      requirements: [
        '本科及以上学历，工程管理、法学、经济类相关专业',
        '5年以上招标代理工作经验，熟悉政府采购、国企集采流程',
        '持有招标师职业资格或中级工程师优先',
        '具备独立操作大型项目招投标全流程的能力',
        '具有优秀的项目沟通与风险控制能力'
      ]
    },
    {
      title: '产品经理（造价数智化方向）',
      location: '宁波',
      salary: '18K-32K · 14薪',
      type: '全职',
      requirements: [
        '3年以上 ToB 产品经理经验，有工程造价、建筑信息化产品经验优先',
        '熟悉 SaaS 产品设计，能独立完成需求分析、原型设计、数据分析',
        '了解 AI、BIM、成本管控等新技术在造价领域的应用场景',
        '具备优秀的跨部门沟通协调能力，推动产品快速落地'
      ]
    }
  ];

  const culture = [
    {
      icon: <FiTrendingUp />,
      title: '成长加速',
      desc: '导师制 + 项目共创机制，合伙人直接带队，快速成长为行业专家。'
    },
    {
      icon: <FiCoffee />,
      title: '开放协作',
      desc: '造价、审计、AI、BIM、产品多团队协同，跨专业学习分享无壁垒。'
    },
    {
      icon: <FiAward />,
      title: '共创激励',
      desc: '项目利润分享、年度绩效奖金、专项创新奖励，与公司共成长。'
    }
  ];

  const benefits = [
    '14-16 薪 + 项目绩效 + 股权激励',
    '五险一金 + 商业保险 + 健康体检',
    '年度出国培训 / 行业峰会参会机会',
    '技术认证、执业资格考试全额报销',
    '弹性工作制，远程办公支持',
    '宁波本地办公 / 提供住房补贴'
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addForm(formData);
    message.success('简历已提交，我们会尽快与您联系！');
    setFormData({ name: '', phone: '', email: '', position: '', resume: '', source: '识道造价' });
  };

  return (
    <main className="careers-page">
      <section className="careers-hero">
        <div className="container">
          <span className="hero-eyebrow">JOIN SIDAO · 宁波</span>
          <h1>加入识道 · 扎根宁波，服务全国造价市场</h1>
          <p>
            识道造价立足宁波，业务覆盖长三角及全国。我们正在寻找造价专家、招标顾问、AI/BIM技术人才。
            在这里，专业与创新并行，本地深耕与全国布局共赢。
          </p>
        </div>
      </section>

      <section className="careers-content">
        <div className="container">
          <div className="culture-grid">
            {culture.map((item, index) => (
              <div key={index} className="culture-card">
                <div className="culture-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="careers-grid">
            <div className="positions-section">
              <div className="section-header">
                <h2>热招岗位</h2>
                <p>请点击“立即申请”或将简历发送至 shidao@yuezhong.com，备注申请岗位。</p>
              </div>

              <div className="positions-list">
                {positions.map((position, index) => (
                  <div key={index} className="position-card">
                    <div className="position-header">
                      <h3>{position.title}</h3>
                      <div className="position-meta">
                        <span><FiMapPin /> {position.location}</span>
                        <span><RmbIcon size={17} /> {position.salary}</span>
                        <span><FiClock /> {position.type}</span>
                      </div>
                    </div>
                    <div className="position-requirements">
                      <h4>任职要求</h4>
                      <ul>
                        {position.requirements.map((req, idx) => (
                          <li key={idx}>{req}</li>
                        ))}
                      </ul>
                    </div>
                    <button
                      className="apply-btn"
                      onClick={() => setFormData({ ...formData, position: position.title })}
                    >
                      立即申请
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <aside className="apply-section">
              <h2>投递简历</h2>
              <p className="apply-tip">留下联系方式，我们将在 1-2 个工作日内与您联系。</p>
              <form className="apply-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label><FiUser /> 姓名 <span className="required">*</span></label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label><FiPhone /> 手机号 <span className="required">*</span></label>
                  <input
                    type="tel"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label><FiSend /> 邮箱</label>
                  <input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label><FiBriefcase /> 意向岗位</label>
                  <input
                    type="text"
                    value={formData.remark}
                    onChange={(e) => setFormData({ ...formData, remark: e.target.value })}
                    placeholder="例如：注册造价工程师"
                  />
                </div>
                {/* <div className="form-group">
                  <label><FiAward /> 上传简历</label>
                  <input
                    type="file"
                    onChange={(e) => setFormData({ ...formData, resume: e.target.files?.[0]?.name || '' })}
                  />
                  {formData.resume && <div className="file-name">已选择：{formData.resume}</div>}
                </div> */}
                <button type="submit" className="submit-btnc">
                  提交简历
                </button>
              </form>
              <div className="apply-note">
                <FiShield />
                <span>我们承诺对所有资料严格保密，仅用于招聘评估。</span>
              </div>
            </aside>
          </div>

          <div className="benefits-section">
            <h2>员工发展与福利支持</h2>
            <div className="benefits-grid">
              {benefits.map((item, index) => (
                <div key={index} className="benefit-card">
                  <FiCheckCircle />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Careers;
